module.exports = __webpack_public_path__ + "static/media/toneheim-logo-white.886dc8b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/toneheim-logo-white.svg
// module id = 213
// module chunks = 0